import HttpClient from "../helpers/HttpClient"
import PaymentType, { PaymentTypeDto } from "./PaymentType"
import { HttpError, isError } from "../helpers/Error"


class PaymentTypeService {
    httpClient: HttpClient<PaymentType, PaymentTypeDto> = new HttpClient<PaymentType, PaymentTypeDto>(PaymentType)

    async GetAllPaymentTypes(): Promise<PaymentType[] | HttpError> {
        const res = await this.httpClient.get("/payment-types")
        if (isError(res)) {
            return res as HttpError
        }
        return (res as PaymentType[])
    }

}

const instance = new PaymentTypeService()
export default instance


// WEBPACK FOOTER //
// ./src/state/payment-type/PaymentTypeService.tsx